<template>
  <el-container class="page-login">
    <!-- logo -->
    <el-header class="login-header" height="260px">
      <span class="logo">
        <img src="./assets/img/loginLogo.png" alt />
      </span>
      <h1 class="title">欢迎使用红塔仁恒运输管理系统</h1>
    </el-header>

    <!-- 账号登录 -->
    <el-main class="login-main">
      <div class="login-index">
        <p class="login-title">企业微信扫码登录</p>
        <div class="qrcodeDiv">
          <div @click="getQRCode" id="qrcode"></div>
        </div>
        <div class="scanedQrcode">
          <template v-if="scanedQrcode">
            <img src="./assets/img/ok.png" alt />
            <p class="p1">扫码成功</p>
            <p class="p2">请在企业微信中点击确认即可登录</p>
          </template>
        </div>
        <!-- <img :src="loginEqCode" alt="" /> -->
      </div>
    </el-main>
    <foot :cpString="cpString"></foot>
  </el-container>
</template>

<script>
import foot from "@/components/pcFrom/foot.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import { menuData } from "./config/menuDataHT";
import QRCode from "qrcodejs2";
// import { filterByPrivilege } from "./config/menuDataYw";
// import io from "socket.io-client";
// console.log(filterByPrivilege);

export default {
  data() {
    return {
      formData: {
        acct: "",
        password: "",
        com_id: "",
        code: ""
      },
      markAcct: false,
      count: 0,
      cpString: menuData.cpString,
      loginType: 1,
      captchaCodeUrl: "",
      loginEqCode: "",
      loginInterval: null,
      qrcodeObj: null,
      scanedQrcode: false
    };
  },
  components: {
    foot
  },

  async created() {
    let host = location.host;
    if (host == "tms.hrpack.com") {
      // 生产
      this.formData.com_id = "ebrbtfhvbgwj90snu4sp5lhp4tulxf67";
    } else if (host == "tmstest.hrpack.com") {
      // UAT
      this.formData.com_id = "ebrbtfhvbgwj90snu4sp5lhp4tulxf67";
    } else {
      // 测试
      this.formData.com_id = "ebrbtfhvbgwj90snu4sp5lhp4tulxf67";
    }
    this.getQRCode();
  },

  mounted() {
    // 填充密码
    this.$nextTick(() => {
      let query = this.$common.getCookie("my_acct");
      if (query) {
        let acctArr = query.split("&").map(item => {
          return item.split("=")[1];
        });
        this.formData.acct = acctArr[0];
        this.formData.password = acctArr[1];
        this.markAcct = true;
      }
    });

    // setTimeout(() => {
    //   this.setAdminInfo({ aaa: 123123, bbb: 444 });
    // }, 5000);
  },

  computed: {
    ...mapGetters([
      "privilegeConfig",
      "adminInfo",
      "socketObj",
      "socketMsgList",
      "firstPath"
    ])
  },

  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.loginInterval);
    next();
  },

  methods: {
    ...mapActions(["fetchPrivilege", "initSocket"]),
    ...mapMutations(["setPrivilegeConfig", "setAdminInfo", "sendSocket"]),

    changeCaptchaCodeUrl() {
      this.captchaCodeUrl =
        "/api/authorize/get_captcha?account=" +
        this.formData.acct +
        "&t=" +
        new Date().getTime();
    },

    async login() {
      const loginRs = await this.$common.http({
        url: "/api/authorize/account_login",
        data: {
          account: this.formData.acct,
          password: this.formData.password,
          com_id: this.formData.com_id,
          code: this.formData.code
        }
      });
      console.log(loginRs);
      if (loginRs.data.errcode == 0) {
        this.$common.pcSuccess("登录成功");
        this.intoSysTem(loginRs.data.data.token, loginRs);
      } else {
        this.captchaCodeUrl =
          "/api/authorize/get_captcha?account=" +
          this.formData.acct +
          "&t=" +
          new Date().getTime();
      }
    },
    // 进入系统
    async intoSysTem(token, res) {
      // window.localStorage.setItem("token", token);
      // token 值
      let projectNameArray = window.location.pathname.split("/");
      let projectName = (projectNameArray[1] || "") + "token";
      window.localStorage.setItem(projectName, token);
      // 同浏览器的不同tab同时刷新
      window.localStorage.setItem("changeFactory", new Date().getTime());
      // 保存当前用户信息
      this.setAdminInfo(res);
      // socket链接
      // this.initSocket();
      // 获取权限
      await this.fetchPrivilege();
      console.log(
        "当前用户权限Privilege",
        this.privilegeConfig,
        this.firstPath
      );
      this.$router.push("/rhqy/lyout");
    },
    // 记住密码
    markAcctFn() {
      if (this.markAcct) {
        const query = `acct=${this.formData.acct}&pass=${this.formData.password}`;
        this.$common.setCookie({
          key: "my_acct",
          value: query,
          expires: 7 * 24 * 60 * 60 * 1000
        });
      } else {
        this.$common.removeCookie("my_acct");
      }
    },
    // 回车登录
    keyupSubmit() {
      // const pThis = this;
      // document.onkeydown = () => {
      //   if (pThis.$route.path === "/rhqy/login") {
      //     let _key = window.event.keyCode;
      //     if (_key === 13) {
      //       pThis.login();
      //     }
      //   }
      // };
    },

    // 发送验证码
    sendCode() {
      if (
        !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/.test(
          this.formData.acct
        )
      ) {
        this.$common.pcError("请输入正确的手机号");
        return;
      }
      this.$common
        .http({
          url: "/qyapi/authorize/send_sms_code",
          data: {
            phone: this.formData.acct
          }
        })
        .then(() => {
          this.count = 60;
          this.$common.success("发送成功");
        });
    },
    getQRCode() {
      if (this.loginInterval) {
        window.clearInterval(this.loginInterval);
      }
      const moblieUrl = encodeURIComponent(
        `/rhwx/index.html#/rhwx/checkPcEqCodeLogin?t=${new Date().getTime()}`
      );
      this.$common
        .http({
          method: "get",
          url: `/api/authorize/get_wxwork_login_qrcode?com_id=${this.formData.com_id}&src_url=${moblieUrl}`
        })
        .then(res => {
          this.uid = res.data.data.uid;
          this.loginEqCode = res.data.data.url;
          if (this.qrcodeObj) {
            this.qrcodeObj.clear();
          }
          console.log(
            `#/rhwx/checkPcEqCodeLogin?com_id=${this.formData.com_id}&uid=${this.uid}`
          );
          document.getElementById("qrcode").innerHTML = "";
          this.qrcodeObj = new QRCode("qrcode", {
            width: 243,
            height: 243,
            text: this.loginEqCode
          });
          this.startLoginInterval();
        });
    },
    changeLoginType() {
      if (this.loginType == 1) {
        this.loginType = 2;
        this.getQRCode();
      } else {
        this.loginType = 1;
        window.clearInterval(this.loginInterval);
      }
    },
    startLoginInterval() {
      this.loginInterval = window.setInterval(() => {
        this.$common
          .http({
            method: "get",
            url: `/api/authorize/wxwork_qrcode_login_check?uid=${this.uid}`,
            noLoading: true
          })
          .then(res => {
            if (res.data.data.token) {
              if (res.data.data.status == "CONFIRM") {
                this.$common.pcToastSuccess("已确认登录");
              }
              window.clearInterval(this.loginInterval);
              this.intoSysTem(res.data.data.token, {});
            } else {
              if (res.data.data.status == "SCANED") {
                this.scanedQrcode = true;
                // this.$common.pcToastSuccess("已扫描，等待确认登录");
              }
              if (res.data.data.status == "CANCEL") {
                this.scanedQrcode = false;
                this.$common.pcToastFail("已取消登录");
                this.getQRCode();
              }
              if (res.data.data.status == "NO_PERMISSION") {
                this.scanedQrcode = false;
                this.$common.pcToastFail("无权限");
                this.getQRCode();
              }
              if (res.data.data.status == "INVALID") {
                this.scanedQrcode = false;
                // this.$common.pcToastFail("无效二维码");
                this.getQRCode();
              }
              if (res.data.data.status == "ACCOUNT_INVALID") {
                this.scanedQrcode = false;
                this.$common.pcToastFail("找不到对应账号");
                this.getQRCode();
              }
            }
          });
      }, 1500);
    }
  },
  watch: {
    count() {
      setTimeout(() => {
        if (this.count > 0) {
          this.count--;
        }
      }, 1000);
    },
    privilegeConfig(n) {
      console.log("权限变化", n);
    },
    adminInfo() {
      console.log("adminInfo变化");
    }
  }
};
</script>

<style scoped lang="less">
.page-login {
  height: 100vh;
  .qrcodeDiv {
    width: 283px;
    height: 283px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #e2e2e2;
    margin: 0 auto;
    position: relative;
  }
  .scanedQrcode {
    padding-top: 10px;
    padding-left: 115px;
    height: 57px;
    position: relative;
    img {
      position: absolute;
      left: 70px;
      top: 17px;
      width: 40px;
    }
    p {
      text-align: left;
      margin: 0;
    }
    .p1 {
      font-size: 20px;
    }
  }
  .hide {
    display: none;
  }
  .captchaCode {
    width: 65%;
  }
  .captchaCodeImg {
    position: absolute;
    width: 34%;
    right: 0;
    cursor: pointer;
  }
  .login-index {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    padding-top: 42px;
    padding-bottom: 42px;
    margin-top: 30px;
    color: #353535;
    border-radius: 5px;
    text-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 432px;
    box-sizing: border-box;

    .codeImg {
      position: absolute;
      right: 0;
      top: 0;
      width: 33px;
      cursor: pointer;
    }
    .textImg {
      position: absolute;
      right: 30px;
      top: 3px;
      width: 80px;
    }
  }
  .login-header {
    display: flex;
    justify-content: center;
    align-items: center;
    background: url(./assets/img/home_bg.png) no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    .title {
      margin-left: 28px;
      font-size: 46px;
      color: #fff;
    }
  }
  .login-main {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 0;
    height: calc(100vh - 300px);
    background: url(./assets/img/main_bg.png) no-repeat;
    background-size: cover;

    .login-title {
      margin: 0 0 20px 0;
      font-size: 24px;
      color: #000000;
      text-align: center;
    }

    .controler {
      text-align: center;
      cursor: pointer;
      .controler-check {
        overflow: hidden;
        width: 100%;
        .check-left {
          float: left;
          width: 50px;
        }
        .check-right {
          float: right;
        }
      }
      .login-btn {
        width: 100%;
        margin-top: 3px;
        height: 38px;
        border-radius: 4px;
        font-size: 14px;
      }
      .controler-info {
        margin-top: 20px;
        font-size: 14px;
      }
    }
  }
}
</style>
